import React from 'react';

import * as helpers from './helpers';

const InfoIcon = ({
  color,
  width = 25,
  height = 25,
  ...props
}: {
  color: string,
  width: number,
  height: number,
}) => (
  <svg {...helpers.getSvgDimensionsProps({ width, height })} {...props}>
    <path
      d="M12.5 0C5.5971 0 0 5.5971 0 12.5C0 19.4029 5.5971 25 12.5 25C19.4029 25 25 19.4029 25 12.5C25 5.5971 19.4029 0 12.5 0ZM12.5 22.8795C6.76897 22.8795 2.12054 18.231 2.12054 12.5C2.12054 6.76897 6.76897 2.12054 12.5 2.12054C18.231 2.12054 22.8795 6.76897 22.8795 12.5C22.8795 18.231 18.231 22.8795 12.5 22.8795Z"
      fill="#C3A573"
    />
    <path
      d="M11.1607 7.58929C11.1607 7.94449 11.3018 8.28514 11.553 8.5363C11.8041 8.78747 12.1448 8.92857 12.5 8.92857C12.8552 8.92857 13.1958 8.78747 13.447 8.5363C13.6982 8.28514 13.8393 7.94449 13.8393 7.58929C13.8393 7.23409 13.6982 6.89343 13.447 6.64227C13.1958 6.3911 12.8552 6.25 12.5 6.25C12.1448 6.25 11.8041 6.3911 11.553 6.64227C11.3018 6.89343 11.1607 7.23409 11.1607 7.58929ZM13.1696 10.7143H11.8303C11.7076 10.7143 11.6071 10.8147 11.6071 10.9375V18.5268C11.6071 18.6496 11.7076 18.75 11.8303 18.75H13.1696C13.2924 18.75 13.3928 18.6496 13.3928 18.5268V10.9375C13.3928 10.8147 13.2924 10.7143 13.1696 10.7143Z"
      fill="#C3A573"
    />
  </svg>
);

export default InfoIcon;
